"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterAbilityHandler = exports.CounterActorAbilityFactory = exports.CounterAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Damage_1 = require("../../core/Damage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class CounterAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Counter;
        this.__typeName = "Counter";
    }
}
exports.CounterAbilityArgs = CounterAbilityArgs;
let CounterActorAbilityFactory = class CounterActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Counter", "Self", 3);
    }
};
CounterActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Counter")
], CounterActorAbilityFactory);
exports.CounterActorAbilityFactory = CounterActorAbilityFactory;
let CounterAbilityHandler = class CounterAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const baseDamage = container.getPercentOfBaseAttributeScore(ability.invokerId, 150, "Power");
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.DamageReciprocateEffectArgs(new Damage_1.Damage(enums_1.DamageType.Physical, baseDamage))
                });
            }
        });
    }
};
CounterAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Counter)
], CounterAbilityHandler);
exports.CounterAbilityHandler = CounterAbilityHandler;
